export default __webpack_public_path__ + "static/media/longchamp20.f32e8807.jpg";